// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2ea9b99c","732":"9eb28da5","977":"d4e04df0"}[chunkId] + ".chunk.js";
};